import { APIHelper } from '@archistarai/auth-frontend';

export default {
  namespaced: true,
  state: {
    exchangeRates: [],
    currencyOptions: [],
    currencyAllowedDirectDebit: ['AUD'],
    currencyCountries: {
      AUD: ['AU'],
      USD: ['US'],
      GBP: ['GB'],
      EUR: ['GB']
    }
  },
  getters: {
    whereExchangeRateCurrentCurrencyCode(state) {
      return (currencyCode) => state.exchangeRates.find((er) => er.currency_code === currencyCode);
    },
    selectCurrencyCountries(state) {
      return Object.keys(state.currencyCountries);
    }
  },
  mutations: {
    ADD_CURRENCY_OPTIONS(state, currencyOptions) {
      state.currencyOptions = currencyOptions;
    },
    ADD_EXCHANGE_RATES(state, exchangeRates) {
      state.exchangeRates = exchangeRates;
    }
  },
  actions: {
    async getExchangeRates({ commit }) {
      try {
        const {
          data: { data: exchangeRates }
        } = await APIHelper.AdminAPI.get('/currencies');
        commit('ADD_EXCHANGE_RATES', exchangeRates);
        return exchangeRates;
      } catch (e) {
        throw e;
      }
    },
    async getCurrencyOptions({ commit }) {
      try {
        const {
          data: { data: currencyOptions }
        } = await APIHelper.AdminAPI.get('/currencies/options');
        commit(
          'ADD_CURRENCY_OPTIONS',
          Object.keys(currencyOptions).map((k) => ({ value: k, label: currencyOptions[k] }))
        );
        return currencyOptions;
      } catch (e) {
        throw e;
      }
    }
  }
};
